import { FormErrors } from 'redux-form';

import { MagentoCardState } from 'components/settings/reducers/sections/magentoCards';

import type { ValidateErrors } from '../cards.types';

export function validate(values: MagentoCardState): FormErrors {
  const errors: ValidateErrors = { hook: {} };

  if (!values) {
    return errors;
  }

  if (!values?.hook?.title?.trim()) {
    errors.hook.title = 'Please add a title';
  }

  if (!values?.hook?.apikey?.trim()) {
    errors.hook.apikey = 'Please add an API key';
  }

  if (!values?.hook?.magentoSubdomain?.trim()) {
    errors.hook.magentoSubdomain = 'Please add a subdomain';
  }

  if (!values?.template?.trim()) {
    errors.template = 'Please add some template content';
  }

  return errors;
}

export const apiKeyHelpText = `Please insert the API key corresponding to the Magento account that you want Dixa to receive data from.`;
export const subdomainHelpText = `Please insert your Magento subdomain name here.`;
